import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";
import optimization from "../../assets/icons/optimize.png";

const SFservice = () => {
  return (
    <div className="sf-services">
      <h3>Web Development Services</h3>
      <p className="sf-description">
        We offer comprehensive and end result-pushed web development services
        designed to assist organizations build a robust on line presence and
        reap lengthy-term boom.
      </p>

      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>Custom Website Development</h3>
          <p>
            We create fully customized websites tailored to your business needs.
            Our solutions are designed to reflect your brand identity and
            provide a seamless user experience.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Responsive Web Design</h3>
          <p>
            Our team develops mobile-friendly and responsive websites that work
            perfectly on all devices, including desktops, tablets, and
            smartphones.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>E-commerce Website Development</h3>
          <p>
        As a professional <b>ecommerce
            development company in noida</b>, we build scalable and secure online
            stores that help you grow your business.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>CMS Development</h3>
          <p>
            We develop easy-to-manage websites using CMS platforms like
            WordPress, allowing you to update your content without technical
            knowledge.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3>Website Redesign Services</h3>
          <p>
            We upgrade outdated websites with modern designs, improved
            functionality, and better performance to meet current market
            standards.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>SEO-Friendly Development</h3>
          <p>
            We build websites with clean code and optimized structure to improve
            search engine rankings and visibility.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Speed Optimization & Performance</h3>
          <p>
            We optimize your website for faster loading speed, better
            performance, and improved user experience.{" "}
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Web Application Development</h3>
          <p>
            We develop dynamic and scalable web applications tailored to your
            business processes and requirements.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Website Maintenance & Support</h3>
          <p>
            We provide ongoing maintenance, updates, and technical support to
            ensure your website runs smoothly and securely.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SFservice;
